function setState(key: string, value: unknown): void {
    localStorage.setItem(key, JSON.stringify(value));
}

function getState<T = unknown>(key: string): T | null {
    const jsonValue = localStorage.getItem(key);

    if (!jsonValue) {
        return null;
    }

    return JSON.parse(jsonValue);
}

const localStorageService = {
    setState,
    getState,
};

export default localStorageService;
